// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d4b64d64","453":"35423958","455":"148a62c6","977":"e08ce853"}[chunkId] + ".chunk.js";
};